import React from 'react';

const MarketerFooter: React.FC = () => {
  return (
    <footer className="py-12 bg-slate-950 border-t border-slate-900 text-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center">
        <div className="text-slate-500 mb-4 md:mb-0">
          &copy; {new Date().getFullYear()} ProGeoData. All rights reserved.
        </div>
        
        <div className="flex space-x-6">
           <a href="/" className="text-slate-500 hover:text-white transition-colors">Home</a>
           <a href="?page=privacy" className="text-slate-500 hover:text-white transition-colors">Privacy Policy</a>
           <a href="?page=terms" className="text-slate-500 hover:text-white transition-colors">Terms of Service</a>
           <a href="?page=docs" className="text-slate-500 hover:text-white transition-colors">API Documentation</a>
        </div>
      </div>
    </footer>
  );
};

export default MarketerFooter;